export enum UserActionTypes {
    SET_USERS = "SET_USERS",
    CLEAR_USERS = "CLEAR_USERS"
}